
import { ListDataSource } from "@/data/List/ListDataSource";
import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import FunnelStageLeads from "./funnel-stage-leads.vue";
import draggable from "vuedraggable";
import _ from "lodash";
@Component({
  components:{
    FunnelStageLeads,
    draggable
  }
})
export default class FunnelStages extends Vue {
  @Prop() leadFunnel:any
  @Prop() clientDataSource!:ListDataSource
  @Prop() leadClassDataSource!:ListDataSource


  $message:any
  dataSource:ListDataSource = new ListDataSource({
    className:"LeadFunnelStage",
    config:{}
  })

  @Watch("leadFunnel", {deep:true})
  onLeadFunnelChange(funnel:any){ 
    this.dataSource.items = funnel.stages;
  }

  async dragItem(){
    await this.dataSource.changePriority(null,false,{parentId:this.leadFunnel.id})
  }

  async remove(item:any){
    
    if(item.funnelStageLeads.length > 0){
      this.$message("С начало удалите этапы","error")
      return;
    }
    await this.dataSource.remove(item.id)
  }

  async add(index:number){
    await this.dataSource.add({
      caption:"Этап " + (this.dataSource.items.length + 1),
      leadFunnelId: this.leadFunnel.id
    },false,index+1)
  }

  created(){
    this.dataSource.items = this.leadFunnel.stages.sort((p: any, n: any) => p.priority - n.priority)
  }

  
}
